// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__loading--center__QpnV8 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.index-module__space--width__PN4iv {
  width: 100%;
}
.index-module__button-loader__AHdmC {
  width: 50%;
}
@media only screen and (min-width: 300px) and (max-width: 600px) {
  .index-module__loading--center__QpnV8 {
    width: 120px;
    left: 58% !important;
  }
}
@media only screen and (min-width: 600px) and (max-width: 800px) {
  .index-module__loading--center__QpnV8 {
    width: 120px;
    left: 55% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Loading/index.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,YAAY;IACZ,oBAAoB;EACtB;AACF;AACA;EACE;IACE,YAAY;IACZ,oBAAoB;EACtB;AACF","sourcesContent":[".loading--center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.space--width {\n  width: 100%;\n}\n.button-loader {\n  width: 50%;\n}\n@media only screen and (min-width: 300px) and (max-width: 600px) {\n  .loading--center {\n    width: 120px;\n    left: 58% !important;\n  }\n}\n@media only screen and (min-width: 600px) and (max-width: 800px) {\n  .loading--center {\n    width: 120px;\n    left: 55% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading--center": `index-module__loading--center__QpnV8`,
	"space--width": `index-module__space--width__PN4iv`,
	"button-loader": `index-module__button-loader__AHdmC`
};
export default ___CSS_LOADER_EXPORT___;
